<div class="app-banner u-primary u-align-items-center">
	<div class="mat-headline-2" i18n>weldNet® Equipment Konfigurator</div>

	<div class="d-none d-lg-block">
		<img alt="böhlerwelding by voestalpine" src="assets/images/logo-boehler-small.png">
	</div>
</div>
